import { isSome } from 'core/utils';
import _ from 'lodash';

class FormHelperService {
	constructor() {}

	// Form.update() method is not working correctly
	updateForm = (form, item, deepUpdate = false) => {
		const fieldsToAdd = [];
		form.each(field => {
			if (isSome(item[field.key])) {
				if (_.isObject(item[field.key])) {
					if (item[field.key].length >= 1 && deepUpdate) {
						const fieldToAdd = { field, values: [] };
						_.each(item[field.key], val => {
							if (!val.label && !val.name) {
								fieldToAdd.values.push(val);
							}
						});
						fieldsToAdd.push(fieldToAdd);
					}
				}
				field.set('value', item[field.key]);
			}
		});
		_.each(fieldsToAdd, ({ field, values }) => {
			_.each(values, value => {
				field.add(value);
				field.set('value', item[field.key]);
			});
		});
	};
}

export default FormHelperService;



// WEBPACK FOOTER //
// ./src/common/data/FormHelperService.js